import { Component, OnDestroy, ViewEncapsulation, NgModule, ChangeDetectorRef, ChangeDetectionStrategy, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NotifyPopupsService } from '@core/services/system/notify-popups.service';
import { scaleElm } from '@shared/animations';
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'notify-popups',
  templateUrl: './notify-popups.component.html',
  styleUrls: ['./notify-popups.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [scaleElm()],
})
export class NotifyPopups implements OnDestroy {
  public showNotify: boolean = false;
  public notifier: boolean = false;
  public notifyType: string = '';
  public payload: any = null;
  private timeout: ReturnType<typeof setTimeout> | undefined;
  private hideNotifyTimeout: ReturnType<typeof setTimeout> | undefined;

  constructor(private notifyPopupsService: NotifyPopupsService, private cdr: ChangeDetectorRef) {
    this.initNotificationEffect();
  }

  private initNotificationEffect(): void {
    const notificationSignal = toSignal(
      this.notifyPopupsService.notificationEvents().pipe(filter((data) => data?.event)),
      { initialValue: undefined }
    );
    effect(() => {
      const data = notificationSignal();
      if (data === undefined) return;
      this.showNotify = true;
      this.notifier = true;
      this.notifyType = data.event;
      this.payload = data.payload;
      this.cdr.markForCheck();
      this.timeout = setTimeout(() => this.hideNotify(), 1800);
    });
  }

  ngOnDestroy() {
    this.notifyPopupsService.launchNotification(null);
    this.timeout && clearTimeout(this.timeout);
    this.hideNotifyTimeout && clearTimeout(this.hideNotifyTimeout);
  }

  hideNotify() {
    this.notifier = false;
    this.timeout && clearTimeout(this.timeout);
    this.cdr.markForCheck();
    this.hideNotifyTimeout = setTimeout(() => {
      this.notifyPopupsService.launchNotification(null);
      this.showNotify = false;
      this.cdr.markForCheck();
    }, 200);
  }
}
@NgModule({
  imports: [CommonModule, TranslateModule.forChild()],
  declarations: [NotifyPopups],
  exports: [NotifyPopups],
})
export class NotifyPopupsModule {}
